export const REQUEST_KEY = {
    CONNECTION_REQUEST: 1,
    GROUP_JOIN_REQUEST: 2,
    GROUP_INVITE: 3,
    ADHOC_INVITE: 4,
    KIDADHOC_INVITE: 5,
    KIDTEAM_INVITE: 6,
    DEVICE_INVITE: 7
};

/**
 * WILL BE REPLACE by `src/utils/challenge/challengeConstants.js` `SOCIAL_CHALLENGE_TYPE_ID`
 */
export const CHALLENGE_TYPE = {
    AUTO: 0,
    GROUP: 1,
    AD_HOC: 2,
    VIVOKID: 3,
    VIVOKID_TEAMS: 4,
    TEAM: 5,
    BADGE: 6
};

export const REQUEST_STATUS = {
    UNDECIDED: 0,
    PROCESSING: 1,
    ACCEPTED: 2,
    DECLINED: 3,
    UNDOING: 4
};

export const DATA_PRIVACY_ACTION = {
    CANCEL: 0,
    OK: 1,
    DO_NOT_SHOW_AGAIN: 2
};

export const CHALLENGE_DIALOG_TYPE = {
    PRIVACY_CONFIRM: 1,
    CANCEL_CONFIRM: 2,
    PRIVACY_INFO: 3
};
